import React from 'react';
import { Check, Gift } from '@saleshandy/icons';
import { OVERVIEW_CARDS } from './constants';
import { PersonCardMock, CompanyCardMock } from './mock-visuals';

type IProps = {
  creditGiven: boolean;
};

const CARD_VISUALS = [<PersonCardMock />, <CompanyCardMock />];

const OverviewStep: React.FC<IProps> = ({ creditGiven }) => (
  <div className="bs-lf-ext__overview">
    <p className="bs-lf-ext__overview-lead regular-2 gray-txt-9">
      Get contacts, enrich companies, and enroll into sequences right from
      LinkedIn and Sales Navigator.
    </p>

    <div className="bs-lf-ext__cards">
      {OVERVIEW_CARDS.map((card, idx) => (
        <div className="bs-lf-ext__card" key={card.eyebrow}>
          <div className="bs-lf-ext__card-visual">{CARD_VISUALS[idx]}</div>
          <span className="bs-lf-ext__card-eyebrow gray-txt-7">
            {card.eyebrow}
          </span>
          <h4 className="bs-lf-ext__card-title semibold-2 gray-txt-9">
            {card.title}
          </h4>
          <ul className="bs-lf-ext__card-points">
            {card.points.map((point) => (
              <li key={point} className="regular-1 gray-txt-9">
                <Check
                  width={14}
                  height={14}
                  className="bs-lf-ext__check blue-txt-6"
                />
                {point}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    {!creditGiven && (
      <div className="bs-lf-ext__credits-banner">
        <Gift width={22} height={22} className="blue-txt-6" />
        <div>
          <p className="semibold-2 gray-txt-9 mb-0">Get 50 free credits</p>
          <p className="regular-1 gray-txt-11 mb-0">
            Will be added to your account once you install the plugin and log in.
          </p>
        </div>
      </div>
    )}
  </div>
);

export default OverviewStep;
